import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiClient } from '@app/core/services/base-api-client.service';
import { LoadingIndicatorService } from '@app/core/services/loading-indicator.service';
import { LogService } from '@app/core/services/log.service';
import { Environment } from '@env/environment';
import { Observable, catchError, tap } from 'rxjs';
import { Employee } from '../models/employee';

const httpOptions = {
	headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
export interface IEmployeeService {
	url: string;
	getEmployee(): Observable<Employee>;
}
@Injectable({
	providedIn: 'root',
})
export class EmployeeService extends BaseApiClient implements IEmployeeService {
	/**
	 * The base URL for the API domain.
	 */
	public baseUrl: string;

	/**
	 * The URL to the API endpoint.
	 */
	public url: string;

	constructor(
		private readonly http: HttpClient,
		private readonly log: LogService,
		private readonly loadingIndicatorService: LoadingIndicatorService,
		environment: Environment
	) {
		super();
		this.baseUrl = environment.services['employee'];
		this.url = this.baseUrl + 'employee';
	}

	/**
	 * Get Employee Details
	 */
	getEmployee(): Observable<Employee> {
		const url = `${this.url}/Details`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.get<Employee>(url, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}
}
